(function () {
  var STORAGE_KEY = 'cld_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch (e) { return []; }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function isInWishlist(handle) {
    return getWishlist().some(function (item) { return item.handle === handle; });
  }

  function addToWishlist(data) {
    var items = getWishlist();
    if (!items.some(function (item) { return item.handle === data.handle; })) {
      items.unshift(data);
      saveWishlist(items);
    }
  }

  function removeFromWishlist(handle) {
    saveWishlist(getWishlist().filter(function (item) { return item.handle !== handle; }));
  }

  function updateBadges() {
    var hasItems = getWishlist().length > 0;
    document.querySelectorAll('.cld-wishlist-dot').forEach(function (el) {
      el.style.display = hasItems ? '' : 'none';
    });
  }

  function updateButtons() {
    document.querySelectorAll('.cld-wishlist-btn').forEach(function (btn) {
      var active = isInWishlist(btn.dataset.handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-label', active ? 'お気に入りから削除' : 'お気に入りに追加');
      btn.setAttribute('aria-pressed', String(active));
    });
  }

  function heartSVG() {
    return '<svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
  }

  // ── ウィッシュリストページ描画 ──────────────────────
  function renderWishlistPage(container) {
    var items = getWishlist();
    if (items.length === 0) {
      container.innerHTML =
        '<div class="cld-wishlist-empty">' +
          '<svg viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="#ccc" stroke-width="1.5"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>' +
          '<p>お気に入りに登録された商品はありません。</p>' +
          '<a href="/collections/all" class="cld-btn-more">' +
            '商品一覧を見る' +
            '<svg viewBox="0 0 24 24"><path d="M8 5l7 7-7 7" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/></svg>' +
          '</a>' +
        '</div>';
      return;
    }

    var html = '<ul class="cld-catalog-grid">';
    items.forEach(function (item) {
      var escapedTitle = item.title.replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      html +=
        '<li class="cld-catalog-item">' +
          '<div class="cld-pcard">' +
            '<button class="cld-wishlist-btn is-active"' +
              ' data-handle="' + item.handle + '"' +
              ' data-title="' + escapedTitle + '"' +
              ' data-price="' + (item.price || '') + '"' +
              ' data-image="' + (item.image || '') + '"' +
              ' data-url="' + item.url + '"' +
              ' aria-label="お気に入りから削除" aria-pressed="true">' +
              heartSVG() +
            '</button>' +
            '<a href="' + item.url + '" class="cld-pcard__link">' +
              '<div class="cld-pcard__img-wrap">' +
                (item.image
                  ? '<img src="' + item.image + '" alt="' + escapedTitle + '" class="cld-pcard__img" loading="lazy">'
                  : '<div class="cld-pcard__img-placeholder"></div>') +
              '</div>' +
              '<div class="cld-pcard__body">' +
                '<h3 class="cld-pcard__title">' + escapedTitle + '</h3>' +
                (item.price
                  ? '<div class="cld-pcard__prices"><p class="cld-pcard__price"><span class="cld-pcard__price-num">' + item.price + '</span><span class="cld-pcard__price-yen">円</span><span class="cld-pcard__tax">（税抜）</span></p></div>'
                  : '') +
              '</div>' +
            '</a>' +
          '</div>' +
        '</li>';
    });
    html += '</ul>';
    container.innerHTML = html;

    // 削除後に再レンダリング
    container.addEventListener('click', function (e) {
      var btn = e.target.closest('.cld-wishlist-btn');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      removeFromWishlist(btn.dataset.handle);
      updateBadges();
      renderWishlistPage(container);
    });
  }

  // ── 初期化 ──────────────────────────────────────────
  function init() {
    // ハートボタンのクリック（ページ全体で委譲）
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cld-wishlist-btn');
      if (!btn) return;
      // ウィッシュリストページ内は renderWishlistPage 側で処理
      if (btn.closest('#cld-wishlist-container')) return;
      e.preventDefault();
      e.stopPropagation();
      var data = {
        handle: btn.dataset.handle,
        title:  btn.dataset.title,
        price:  btn.dataset.price,
        image:  btn.dataset.image,
        url:    btn.dataset.url,
      };
      if (isInWishlist(data.handle)) {
        removeFromWishlist(data.handle);
      } else {
        addToWishlist(data);
      }
      updateButtons();
      updateBadges();
    });

    updateButtons();
    updateBadges();

    var container = document.getElementById('cld-wishlist-container');
    if (container) renderWishlistPage(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
